import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {compose} from '../../utils'
import Step1 from "../../steps/step1";
import Step2 from "../../steps/step2";
import Step3 from "../../steps/step3/step3";
import Step4 from "../../steps/step4/step4";
import {bindActionCreators} from "redux";
import {setItemData} from "../../actions";

const App = (props) => {
    const [opened, setOpened] = useState(false);

    useEffect(() => {
        document.querySelector("#open-fast-order").addEventListener("click", e => setOpened(true));
    });

    let modalClasses = [
        'modal',
        'modalType2',
        'product-request',
        'modal_oneclick',
    ];
    if (props.step >= 2) {
        modalClasses.push('modal_sucssess-1');
        modalClasses.push('modalType2-steps');
    }

    let overlayClasses = "overlay js-overlay-modal unclose";

    if(opened) {
        overlayClasses += " active";
        modalClasses.push("active");
    }

    return (
        <>
            <div id="modalType2" className={modalClasses.join(" ")}>
                <div className="js-modal-close2" onClick={e => setOpened(false)}><img className="modalType2--closeImg" src="/local/templates/bx-gresso-new_header/img/popup/close.png"/></div>

                {props.step === 1 &&
                <Step1/>
                }

                {props.step === 2 &&
                <Step2/>
                }

                {props.step === 3 &&
                <Step3/>
                }

                {props.step === 4 &&
                <Step4/>
                }
            </div>

            <div className={overlayClasses} />
        </>
    );
};

const mapStateToProps = ({step}) => {
    return {step};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setItemData,
    }, dispatch);
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps)
)(App);
